'use client';

import { useEffect, useState } from 'react';

import { getLogger } from '@/shared/utils/logger/client';

interface Props {
	label?: string;
	data: unknown;
}

export const DebugLogger = ({ label = 'Debug', data }: Props) => {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		getLogger().debug(`[DebugLogger] ${label}`, { data });
	}, [label, data]);

	return (
		<div className="my-4 rounded-lg border border-yellow bg-black/90 text-xs text-white">
			<button
				type="button"
				className="flex w-full items-center gap-2 px-3 py-2 text-left font-mono"
				onClick={() => setOpen((v) => !v)}
			>
				<span className="text-yellow">⚡ {label}</span>
				<span className="ml-auto text-gray-4">
					{open ? '▲ hide' : '▼ show'}
				</span>
			</button>
			{open && (
				<pre className="max-h-[400px] overflow-auto border-t border-yellow/30 p-3 leading-relaxed">
					{JSON.stringify(data, null, 2)}
				</pre>
			)}
		</div>
	);
};
